import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Document } from '@/interfaces/requirement';

type DocumentControl = {
  id: number;
  file: any;
  dateFrom?: Date;
  dateEmit?: Date;
  dateUntil: null | undefined | Date;
  index: number;
}

export function alLeastOneDateEndMustBeNotUndefined(originalArray: Document[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const documents = control.value as DocumentControl[];

    const mergedDocuments = originalArray.map((document, indexOriginal) => {
      const modifiedDocument = documents.find(({ index: indexModified }: { index: number }) => indexOriginal === indexModified);
      if (modifiedDocument) {
        return {
          ...document,
          dateEmit: modifiedDocument.dateEmit,
          dateFrom: modifiedDocument.dateFrom,
          dateUntil: modifiedDocument.dateUntil ? modifiedDocument.dateUntil : undefined,
        };
      }
      return {
        ...document,
        dateUntil: document.dateUntil ? document.dateUntil : undefined,
      };
    });

    if (mergedDocuments.length > 0 && mergedDocuments.every(({ dateUntil }) => dateUntil === undefined)) {
      return {
        description: 'Las fechas "Hasta" no pueden ser todas indefinidas. Por favor, seleccione al menos una fecha en un campo "Hasta".',
        code: '300',
      };
    }
    return null;
  };
}
